import React, { useState } from "react";
import Effects from "../Component/Effects/Effects";
import MuteButton from "../Component/MuteButton/MuteButton";
import Header from "../Component/Header/Header";
import Hero from "../Sections/Hero/Hero";
import Gift from "../Sections/Gift/Gift";
import Cover from "../Sections/Cover/Cover";
import Greetings from "../Sections/Greetings/Greetings";
import Photos from "../Sections/Photos/Photos";
import CakeComponent from "../Sections/Cake/Cake";
import Footer from "../Component/Footer/Footer";

const Homepage = () => {
  const [volume, setVolume] = useState(1.0);

  const handleToggleVolume = () => {
    setVolume((prevVolume) => (prevVolume === 1.0 ? 0.1 : 1.0));
  };

  return (
    <>
      <Effects volume={volume} />
      <MuteButton volume={volume} onToggleVolume={handleToggleVolume} />
      <Header />
      <Hero />
      <Gift />
      <section id="photos">
        <Photos />
      </section>
      <Cover />
      <section id="greetings">
        <Greetings />
      </section>
      <CakeComponent />
      <Footer />
    </>
  );
};

export default Homepage;
